import { AutogenModelCommodity, AutogenRowCommodity } from "./autogen/AutogenModelCommodity";

export class ModelCommodity extends AutogenModelCommodity<RowCommodity> {
    constructor() {
        super(RowCommodity);
    }
}

export class RowCommodity extends AutogenRowCommodity {
}